import { Platform } from 'react-native';

export const isAndroidBuild = () => Platform.OS === 'android';
